import { englishString, pagesText } from './english';

const array = [englishString, pagesText];

export const strText = array[0];
export const pageTitle = array[1];

export const ROLES = {
	ADMIN: {
		VALUE: 1,
		TEXT: 'NOTAP_ADMIN',
		LABEL: 'Admin',
	},
	TRANSFEREE: {
		VALUE: 2,
		TEXT: 'TRANSFEREE_USER',
		LABEL: 'Transferee',
	},
	BANK: {
		VALUE: 0,
		TEXT: 'BANK_USER',
		LABEL: 'Bank Rep',
	},
	DG: {
		VALUE: 11,
		TEXT: 'DG',
		LABEL: 'DG',
	},
	DIRECTOR: {
		VALUE: 12,
		TEXT: 'Director',
		LABEL: 'Director',
	},
	DEPUTY_DIRECTOR: {
		VALUE: 13,
		TEXT: 'DeputyDirector',
		LABEL: 'Deputy Director',
	},
	OFFICERS: {
		VALUE: 14,
		TEXT: 'Officers',
		LABEL: 'Staff',
	},
	EXTERNAL: {
		VALUE: 15,
		TEXT: 'EXTERNAL_USER',
		LABEL: 'External User',
	},
};

export const NOTAP_USER_ROLES = {
	DG: 'dg',
	DIRECTOR: 'director',
	DEPUTY_DIRECTOR: 'deputydirector',
	OFFICERS: 'officers',
};

export const CERTIFICATE_STATUS = {
	CLOSED: 'closed',
	CONFIRMED: 'confirmed',
	APPROVED: 'approved',
	DISAPPROVED: 'disapproved',
	REJECTED: 'rejected',
	PENDING: 'pending',
	DISBURSED: 'disbursed',
};

export const LETTER_DIRECTION = {
	FORWARD: 'forward',
	BACKWARD: 'backward',
};

export const LETTER_TYPE = {
	DRAFT: 'draft',
	SEND_MESSAGE: 'send_message',
	NEXT_USER: 'next_user',
};

export const fileUploadTypes = [
	'application/pdf',
	'image/png',
	'image/jpg',
	'image/jpeg',
];

export const ROLE_LIST = Object.values(ROLES).map((role) => ({
	id: role.VALUE,
	name: role.LABEL,
}));

export const CERTIFICATE_NUMBER_REGEX =
	/^[A-Za-z]{2}\/[A-Za-z]{2}\/\d{9}\/\d+$/;

export const CERTIFICATE_NUMBER_PREFIX = 'CR';
export const imageTypes = ['image/png', 'image/jpg', 'image/jpeg'];
export const DATE_FORMAT_TEMPLATE = 'YYYY-MM-DD';
export const MAX_FILE_SIZE_IN_BYTES = 2_048_000;
